import { render, staticRenderFns } from "./NewFromMedia.vue?vue&type=template&id=75fba8e4&"
import script from "./NewFromMedia.vue?vue&type=script&lang=js&"
export * from "./NewFromMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports